import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-modal w-maxC",
  style: {"padding":"0.3rem"}
}
const _hoisted_2 = {
  key: 1,
  class: "pad-m"
}

import { ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia'
import { useFinancialGroupsStore } from '@/stores/financialGroups'
import { ApiError, FinancialGroupLightResponse } from '@/apiGenerate/medserver';
import { useToast } from 'primevue';
import { toastError } from '@/utils/toast-utils';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import patientapi from '@/api/patientapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'docLuBillAddOnFinancialGroups',
  props: /*@__PURE__*/_mergeModels({
  patientDocument: {
    type: Object,
    required: true,
  },
}, {
    "currFinancialGroup": {},
    "currFinancialGroupModifiers": {},
  }),
  emits: ["update:currFinancialGroup"],
  setup(__props) {

const { t } = useI18n();
const financialGroupsStore = useFinancialGroupsStore();
const currentEntryStore = useCurrentEntryStore();

const toast = useToast();

const { allFinancialGroups } = storeToRefs(financialGroupsStore);
const currFinancialGroup = _useModel<FinancialGroupLightResponse | undefined>(__props, 'currFinancialGroup');
const props = __props;

const dropd = ref();
const currPatientDoc = ref(props.patientDocument);

const isTemplateStatus = computed(() => {
  return currPatientDoc.value.templateStatus === 'Template'
});

watch(
  allFinancialGroups, (financialGroups) => {
    const preferredId = currPatientDoc.value?.financialGroupId;
    currFinancialGroup.value =
      (preferredId && financialGroups.find(g => g.id === preferredId)) ?? null;
  },
  { immediate: true }
)

const filteredFinancialGroups = computed(() => {
  if (!currFinancialGroup.value) return allFinancialGroups.value;
  return allFinancialGroups.value.filter(financialGroup => financialGroup.id !== currFinancialGroup.value!.id);
});

async function setCurrentFinancialGroup(financialGroup: FinancialGroupLightResponse) {
  const previous = currFinancialGroup.value;
  currFinancialGroup.value = financialGroup; // optimistic
  dropd.value = "";

  try {
    const updatedDoc = await patientapi.updatePatientDocumentFinancialGroup(
      currentEntryStore.currentEntryId,
      props.patientDocument.patientDocumentId,
      financialGroup.id.toString()
    );
    currentEntryStore.setCurrentDoc(updatedDoc)
  } catch (error) {
    const apiError = error as ApiError;
    currFinancialGroup.value = previous; // rollback
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: apiError.status ? t(`error.${apiError.status}`) : t('error.DEFAULT')
    });
  }
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (isTemplateStatus.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (filteredFinancialGroups.value.length >= 1)
          ? (_openBlock(), _createBlock(_component_dropdownBox, {
              key: 0,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
              openOn: "FinancialGroups"
            }, {
              dropd: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFinancialGroups.value, (financialGroup) => {
                    return (_openBlock(), _createBlock(_component_listGroup, {
                      key: financialGroup.id,
                      styles: "pad-s",
                      onClick: ($event: any) => (setCurrentFinancialGroup(financialGroup))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          class: "psides-06 txt-primary",
                          txt: financialGroup.title
                        }, null, 8, ["txt"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_buttonGroup, {
                  theme: "dropdown",
                  class: "psides-04"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_text_item, {
                      txt: currFinancialGroup.value?.title || _unref(t)('patient.document.selectFinancialGroup'),
                      class: "btn-text-dimensions txt-primary"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (currFinancialGroup.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_text_item, {
                  txt: currFinancialGroup.value.title,
                  class: "btn-text-dimensions txt-primary"
                }, null, 8, ["txt"])
              ]))
            : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})